<template>
  <div class="create-order">
    <div class="breadcrumb-area pos-relative" style="display: flex; justify-content: space-between">
      <h1>Tạo phiếu điều chuyển</h1>
      <div>
        <button type="button" class="btn btn-secondary flex-grow-1 mr-2" @click="cancel">
          Quay lại
        </button>
        <button
          type="submit"
          @click="submitForm"
          class="btn btn-primary flex-grow-1"
          :disabled="isSubmitting"
        >
          Lưu
        </button>
      </div>
    </div>
    <div class="pt-15 b-t-1-869fb229">
      <div
        class="ml-3 p-3 mt-2"
        style="max-width: 1000px; border: 1px solid #d7d7d7; border-radius: 10px"
      >
        <div class="card-body p-1">
          <form @submit.prevent="submitForm">
            <b-row>
              <b-col md="6">
                <div class="form-group mb-3">
                  <label for="warehouse">Chuyển từ kho <span style="color: red">*</span></label>
                  <Select2
                    type="text"
                    id="warehouse"
                    placeholder="Chọn kho"
                    :options="warehouseUserActiveData"
                    v-model="dataAdd.inventoryIdExport"
                    required
                  />
                  <div v-if="errors.inventoryIdExport" class="text-danger mt-1">
                    {{ errors.inventoryIdExport }}
                  </div>
                </div>
                <div class="form-group mb-3">
                  <label for="agentId">Đơn vị nhận hàng <span style="color: red">*</span></label>
                  <Select2
                    disabled
                    type="text"
                    id="agentId"
                    placeholder="Tìm kiếm..."
                    :options="agentDefault"
                    v-model="formData.agentId"
                    :settings="searchAgent"
                    required
                    @change="loadCategories"
                  />
                </div>

                <div class="form-group mb-3">
                  <label for="regionName">Địa chỉ</label>
                  <textarea
                    id="regionName"
                    disabled
                    style="resize: none; background: #e2e7ed"
                    class="form-control"
                    v-model="formData.agentAddress"
                    rows="5"
                  ></textarea>
                </div>
              </b-col>
              <b-col md="6">
                <div class="order-items-section">
                  <div class="mb-3">
                    <label>Loại thiết bị</label>
                    <label class="float-right">Số lượng</label>
                  </div>
                  <div v-for="(item, index) in orderItems" :key="index" class="mb-2">
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="item-name">{{ item.categoryName }}</div>
                      <input
                        disabled
                        type="number"
                        class="form-control quantity-input"
                        v-model="item.quantity"
                        min="0"
                        style="width: 120px"
                      />
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </form>
        </div>
      </div>
    </div>
    <div class="m-3" style="border: 1px solid #d7d7d7; border-radius: 10px; overflow: hidden">
      <div class="p-4 card">
        <div
          class="mb-2 d-flex pos-relative w-100 justify-content-between align-items-baseline flex-wrap"
        >
          <h1 class="mb-1 form-inner-heading">Danh sách thiết bị điều chuyển</h1>
          <div class="float-right btn-group">
            <button
              type="button"
              @click="deleteDeviceMul"
              v-if="selected.length > 0"
              class="font-medium f12 btn btn-outline-secondary"
            >
              <i class="bx bx-minus-circle"></i> Xoá
            </button>
            <button
              type="button"
              @click="showAddMaterial"
              class="font-medium f12 btn btn-outline-secondary"
            >
              <i class="bx bxs-plus-circle"></i> Chọn vật tư
            </button>
            <button
              type="button"
              @click="exportTemplateTransferWarehouse"
              class="font-medium f12 btn btn-outline-secondary"
            >
              <i class="bx bx-download"></i> Tải file mẫu
            </button>
            <button
              type="button"
              @click="hanldeOpenImportFile"
              class="font-medium f12 btn btn-outline-secondary"
            >
              <i class="bx bx-upload"></i> import file
            </button>
            <button
              type="button"
              @click="showAddDevice"
              class="font-medium f12 btn btn-outline-secondary"
            >
              <i class="bx bxs-plus-circle"></i> Chọn thiết bị
            </button>
            <input
              style="display: none"
              ref="uploadFileExcel"
              @change="uploadFileExcel"
              type="file"
            />
          </div>
        </div>
        <div class="tab-content">
          <div
            class="table-responsive b-table-sticky-header"
            style="overflow: auto; max-height: 70vh"
          >
            <table class="table table-hover table-bordered">
              <thead class="thead-light">
                <tr class="text-center">
                  <th>
                    <input type="checkbox" v-model="selectAll" />
                  </th>
                  <th class="text-left">Tên loại thiết bị</th>
                  <th>Số lượng</th>
                  <th>Mã Serial</th>
                  <th>DVT</th>
                  <th>Tình trạng</th>
                  <th>Ghi chú</th>
                  <th>Thao tác</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="table-row text-center"
                  v-for="(device, index) in dataAdd.devices"
                  :key="`device${index}`"
                >
                  <td>
                    <input type="checkbox" v-model="selected" :value="device" />
                  </td>
                  <td class="text-left">
                    {{ device.text ? device.text : device.categoryName }}
                  </td>
                  <td>{{ device.quantity ? device.quantity : '1' }}</td>
                  <td>{{ device.serial }}</td>
                  <td>
                    {{ device.unit | transformData(Config.unitDevice) }}
                  </td>
                  <td>
                    <span class="badge" :class="[device.type || '']">
                      {{ device.type | transformData(Config.stateDevices) }}
                    </span>
                  </td>
                  <td>
                    <ValidationProvider :vid="device.id" name="Ghi chú">
                      <template slot-scope="{ errors }">
                        <input
                          v-model.trim="device.note"
                          type="text"
                          class="form-control"
                          placeholder="Ghi chú"
                        />
                        <p class="text-danger">{{ errors[0] }}</p>
                      </template>
                    </ValidationProvider>
                  </td>
                  <td>
                    <b-button type="button" size="md" variant="danger" @click="deleteDevice(index)">
                      Xoá
                    </b-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="modal-noti"
      size="lg"
      centered
      v-model="modalChooseDevice"
      ignore-enforce-focus-selector="input"
    >
      <template #modal-header="{ close }">
        <h5>Chọn thiết bị</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          @click="close()"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <form @submit.prevent="filterDevice" class="box-search">
        <div class="form-group">
          <Select2
            placeholder="Loại thiết bị"
            v-model="searchDevice.text"
            :options="deviceCatData"
          />
        </div>
        <div class="form-group" v-if="isAll === true">
          <input
            v-model.trim="searchDevice.numberGear"
            type="text"
            class="form-control"
            placeholder="Số thùng"
          />
        </div>
        <div class="form-group">
          <input
            v-model.trim="searchDevice.serial"
            type="text"
            class="form-control"
            placeholder="Mã serial"
          />
        </div>
        <div class="form-group form-group-action d-flex" style="gap: 5px">
          <button type="submit" class="font-medium btn btn-outline-secondary" @click="filterDevice">
            Lọc
          </button>
          <button
            type="buton"
            @click="unFilterDevice"
            class="font-medium btn btn-outline-secondary"
          >
            Bỏ lọc
          </button>
        </div>
      </form>
      <div class="table-responsive b-table-sticky-header">
        <div style="max-height: 400px; overflow: auto">
          <table class="table table-hover table-bordered">
            <thead class="thead-light">
              <tr class="text-center">
                <th>
                  <input type="checkbox" v-model="selectAllDevice" />
                </th>
                <th>Loại thiết bị</th>
                <th>Mã Serial</th>
                <th>DVT</th>
                <th>Tình trạng</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="table-row text-center"
                v-for="(device, index) in dataMaterial"
                :key="`dataMaterial${index}`"
              >
                <td>
                  <input id="checkbox" type="checkbox" v-model="selectedDevice" :value="device" />
                </td>
                <td class="text-left">{{ device.text }}</td>
                <td>{{ device.serial }}</td>
                <td>{{ device.unit | transformData(Config.unitDevice) }}</td>
                <td>
                  <span class="badge" :class="[device.type || '']">
                    {{ device.type | transformData(Config.stateDevices) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button @click="requestDevices()" size="md" variant="primary"> Thêm </b-button>
        <b-button size="md" variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>
    <div v-if="showModalNoti">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    @click="showModalNoti = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="text-center modal-body">
                  <img :src="srcImage" alt="icon-successs" />
                  <h2 class="py-3 f18">{{ messNoti }}</h2>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-light"
                    @click="showModalNoti = false"
                    data-dismiss="modal"
                  >
                    Đóng
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <modalAddMaterial
      v-if="isShowAddMaterial"
      @updateStatus="updateStatus"
      :dataMaterial="dataMaterial"
      @onHidden="onHidden"
    />
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { CommonService } from '@/services/common.service'
  import { DeviceService } from '@/services/device.service'
  import { mapGetters } from 'vuex'
  import cloneDeep from 'lodash/cloneDeep'
  import differenceBy from 'lodash/differenceBy'
  import Config from '../../../thirdParty/config'
  import modalAddMaterial from '../../device/transferWarehouse/modalAddMaterial.vue'

  export default {
    name: 'OrderCreate',
    components: {
      modalAddMaterial,
    },
    data() {
      return {
        Config,
        idUpdate: this.$route.params.id,
        showLoading: false,
        isSubmitting: false,
        errors: {
          inventoryIdExport: '',
        },
        deviceCatData: [],
        modalChooseDevice: false,
        selected: [],
        selectedDevice: [],
        dataAdd: {
          devices: [],
          typeImport: 'IMPORT_ODD',
        },
        formData: {
          agentId: '',
          dateEstimate: '',
          note: '',
          orderDetail: [],
        },
        searchDevice: {},
        agentDefault: [],
        partnerCodeMap: [],
        searchAgent: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }
              const keySearch = txtSearch ?? ''
              if (this.tLoadOwner) {
                clearTimeout(this.tLoadOwner)
              }
              this.tLoadOwner = setTimeout(() => {
                CommonService.getListAgentBank({
                  keyword: keySearch,
                  sortResultList: [
                    {
                      field: 'createdDate',
                      direction: 'DESC',
                    },
                  ],
                }) // AI
                  .then(res => {
                    success({
                      results:
                        res.data?.map(item => {
                          return {
                            id2: item?.partnerCode,
                            id: item?.agentId,
                            text: item.name || '',
                          }
                        }) || [],
                    })

                    this.partnerCodeMap =
                      res.data?.map(item => {
                        return {
                          partnerCode: item?.partnerCode,
                          agentId: item?.agentId,
                        }
                      }) || []
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },
        isAll: false,
        dataMaterial: [],
        warehouseUserActiveData: [],
        orderItems: [],
        loadingCategories: false,
        typeDevice: '',
        showModalNoti: false,
        isShowAddMaterial: false,
        dataFilter: [],
        srcImage: '',
        messNoti: '',
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      selectAll: {
        get: function () {
          return this.dataAdd.devices ? this.selected.length === this.dataAdd.devices.length : false
        },
        set: function (value) {
          if (value) {
            this.selected = cloneDeep(this.dataAdd.devices)
          } else this.selected = []
        },
      },
      selectAllDevice: {
        get: function () {
          return this.dataMaterial ? this.selectedDevice.length === this.dataMaterial.length : false
        },
        set: function (value) {
          if (value) {
            this.selectedDevice = cloneDeep(this.dataMaterial)
          } else this.selectedDevice = []
        },
      },
    },

    created() {
      if (this.idUpdate) {
        this.fetchĐata()
      }
      this.fetchWarehouse()
      this.fetchCatDevice()
    },
    methods: {
      async fetchCatDevice() {
        const response = await DeviceService.typeDeviceConfig()
        this.deviceCatData = response.data.map(({ name }) => {
          return { id: name, text: name }
        })
      },
      hanldeOpenImportFile() {
        this.dataAdd.typeImport = 'IMPORT_FILE'
        if (!this.dataAdd.inventoryIdExport) {
          this.showErr('Vui lòng chọn kho chuyển trước khi import file')
          return
        }
        this.$refs.uploadFileExcel.click()
      },

      async filterDevice() {
        const deviceData = this.dataFilter.filter(s => {
          const rules = []
          if (this.searchDevice.serial) {
            rules.push(s.serial.toLowerCase().indexOf(this.searchDevice.serial.toLowerCase()) > -1)
          }
          if (this.searchDevice.numberGear) {
            rules.push(
              s.numberGear.toLowerCase().indexOf(this.searchDevice.numberGear.toLowerCase()) > -1
            )
          }
          if (this.searchDevice.text) {
            rules.push(s.text === this.searchDevice.text)
          }
          return !rules.includes(false)
        })
        this.dataMaterial = deviceData
      },
      async fetchDeviceByInventory() {
        this.loading = true
        const response = await DeviceService.listDeviceByInventory({
          inventoryId: this.dataAdd.inventoryIdExport,
          reason: 'TRANSFER_PARTNER',
          kind: 'SERIAL',
        })
        this.deviceFilterData = response.data
        this.dataMaterial = response.data.map(item => {
          return {
            id: item.id,
            text: item.categoryName,
            serial: item.serial,
            type: item.type,
            unit: item.unit,
          }
        })
        this.dataFilter = this.dataMaterial
        this.loading = false
      },
      unFilterDevice() {
        this.searchDevice = {}
        this.fetchDeviceByInventory()
      },
      deleteDevice(index) {
        const h = this.$createElement
        const messageVNode = h('p', {
          domProps: {
            innerHTML: 'Bạn chắc chắn xoá thiết bị trên!',
          },
        })
        this.$bvModal
          .msgBoxConfirm([messageVNode], {
            title: 'Xoá thiết bị',
            okTitle: 'Xoá',
            cancelTitle: 'Huỷ',
            centered: true,
          })
          .then(value => {
            if (value) {
              this.dataAdd.devices.splice(index, 1)
            }
          })
      },
      deleteDeviceMul() {
        const h = this.$createElement
        const messageVNode = h('p', {
          domProps: {
            innerHTML: 'Bạn chắc chắn xoá những thiết bị đã được chọn trên!',
          },
        })

        this.$bvModal
          .msgBoxConfirm([messageVNode], {
            title: 'Xoá thiết bị',
            okTitle: 'Xoá',
            cancelTitle: 'Huỷ',
            centered: true,
          })
          .then(value => {
            if (value) {
              this.dataAdd.devices = differenceBy(this.dataAdd.devices, this.selected, 'id')
              this.selected = []
            }
          })
      },
      async exportTemplateTransferWarehouse() {
        try {
          this.loading = true
          await DeviceService.exportTemplateTransferWarehouse()
        } finally {
          this.loading = false
        }
      },
      async dowloadFileError(reqs) {
        try {
          this.loading = true
          await DeviceService.exportDeviceExcelTransferWarehouse(reqs)
        } finally {
          this.loading = false
        }
      },
      showAddDevice() {
        this.searchDevice.text = ''
        this.searchDevice.numberGear = ''
        this.searchDevice.serial = ''

        this.dataAdd.typeImport = 'IMPORT_ODD'
        if (!this.dataAdd.inventoryIdExport) {
          this.showErr('Vui lòng chọn kho chuyển trước khi chọn thiết bị')
          return
        }
        // this.modalChooseDevice = true
        this.fetchDeviceByInventory()
        this.$nextTick(() => {
          this.$bvModal.show('modal-noti')
        })
      },
      showMsgOk(data) {
        const h = this.$createElement
        // Using HTML string
        const titleVNode = h('div', {
          domProps: { innerHTML: 'Kết quả' },
        })
        // More complex structure
        const messageVNode = h('div', { class: ['text-center'] }, [
          h('p', { class: ['text-center'] }, ['Đã tải dữ liệu xong']),
          h('p', { class: ['text-center'] }, [
            'Số bản ghi thành công ',
            h('b', `${data.correctList && data.correctList.length ? data.correctList.length : 0}`),
            ' bản ghi',
          ]),
          h('p', { class: ['text-center'] }, [
            'Số bản ghi thất bại ',
            h('b', `${data.errorList && data.errorList.length ? data.errorList.length : 0}`),
            ' bản ghi',
          ]),
          // data.errorList.length > 0 && &&
          h(
            'button',
            {
              class: 'f12 font-medium btn btn-outline-danger',
              on: {
                click: () => this.dowloadFileError(data.errorList),
              },
            },
            'Tải bản ghi thất bại'
          ),
        ])
        this.$bvModal.msgBoxOk([messageVNode], {
          title: [titleVNode],
          centered: true,
        })
      },
      async uploadFileExcel(file) {
        if (file.target.files.length === 0) return
        const allowedExtensions = /(\.xls|\.xlsx|\.csv|\.ods)$/i
        const checkFomat = allowedExtensions.exec(file.target.files[0].name)
        if (!checkFomat) {
          this.showErr('Định dạng không hợp lệ !')
          this.$refs.uploadFileExcel.value = null
          return
        }
        const formdata = new FormData()
        formdata.append('file', file.target.files[0])
        formdata.append('inventoryId', this.dataAdd.inventoryIdExport)
        try {
          this.loading = true
          const res = await DeviceService.importDeviceExcelTransferWarehouse(formdata)
          if (res.code === 1000) {
            const arr = [...(res.data?.correctList || []), ...(this.dataAdd?.devices || [])]
            this.dataAdd.devices = this.getUnique(arr, 'id')
            this.showMsgOk(res.data)
          } else if (res.code === 1020 || res.code === 1007) {
            this.showErr(
              'Thông tin trong file không đúng quy định hoặc dung lượng file quá lớn (tối đa 25MB)'
            )
          } else if (res.code === 1021 || res.code === 1040) {
            this.showErr(res.res[0].message)
          } else {
            this.showErr(res.message)
          }
        } catch (e) {
          this.showErr(
            'Thông tin trong file không đúng quy định hoặc dung lượng file quá lớn (tối đa 25MB)'
          )
        } finally {
          this.$refs.uploadFileExcel.value = null
          this.loading = false
        }
      },

      getUnique(arr, comp) {
        const unique = arr
          .map(e => e[comp])
          .map((e, i, final) => final.indexOf(e) === i && i)
          .filter(e => arr[e])
          .map(e => arr[e])

        return unique
      },
      async fetchWarehouse() {
        const response = await DeviceService.getListWarehouseUserActive()
        this.warehouseUserActiveData =
          response.data.map(({ id, name, level, regions, cityCode }) => {
            return { id, text: name, level, regions, cityCode }
          }) || []
      },
      async fetchĐata() {
        this.showLoading = true
        try {
          const data = await DeviceService.DetailOrderFormPartner({ id: this.idUpdate })
          if (data.code === 1000) {
            this.agentDefault = [
              {
                id: data.data.agentId,
                text: data.data.agentName,
              },
            ]
            this.formData.agentId = data.data.agentId
            this.formData.dateEstimate = new Date(data.data.estimatedTime)
              .toISOString()
              .split('T')[0]
            this.formData.regionName = data.data.regionName
            this.formData.agentAddress = data.data.agentAddress

            this.orderItems = data.data.orderDetail || []
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      async loadCategories(id) {
        this.orderItems = []
        this.loadingCategories = true
        const idPartner = this.partnerCodeMap.find(item => item.agentId === id)?.partnerCode || ''
        try {
          const data = await DeviceService.getListDevicePartner({ partnerCode: idPartner })
          if (data.code === 1000) {
            this.orderItems = data.data.map(item => {
              return {
                categoryId: item.id,
                categoryName: item.name,
                quantity: 0,
              }
            })
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.loadingCategories = false
        }
      },
      validateForm() {
        let isValid = true
        this.errors = {
          inventoryIdExport: '',
        }
        // Validate đơn vị nhận hàng
        if (!this.dataAdd.inventoryIdExport || this.dataAdd.inventoryIdExport.trim() === '') {
          this.errors.inventoryIdExport = 'Vui lòng chọn kho chuyển'
          isValid = false
        }

        return isValid
      },
      showErr(message) {
        this.showModalNoti = true
        this.messNoti = message
        this.srcImage = require('@/assets/img/noti-unsuccess2.svg')
      },

      requestDevices() {
        const arr = [...this.selectedDevice, ...this.dataAdd.devices]
        this.dataAdd.devices = this.getUnique(arr, 'id')
        this.modalChooseDevice = false
        this.selectedDevice = []
      },
      submitForm() {
        if (!this.validateForm()) {
          // AI
          return // AI
        } // AI

        // Chuyển dữ liệu từ orderItems vào formData.orderDetail // AI
        const payload = {
          inventoryIdExport: this.dataAdd.inventoryIdExport,
          purchaseOrderId: this.idUpdate,
          typeImport: this.dataAdd.typeImport,
          devices:
            this.dataAdd.devices.map(({ id, note, serial, kind, quantity, text }) => {
              if (kind && quantity) {
                return { id, note, kind, quantity, categoryName: text }
              } else return { id, note, serial, categoryName: text }
            }) || [],
        }

        this.onSubmitAdd(payload) // AI
      }, // AI
      async onSubmitAdd(params) {
        // AI
        try {
          // AI
          this.showLoading = true // AI
          this.isSubmitting = true // AI
          // AI
          // Ngược lại gọi API tạo mới // AI
          const data = await DeviceService.AddOrderFormPartner(params) // AI
          if (data.code === 1000) {
            // AI
            const message = 'Tạo phiếu đặt hàng thành công' // AI
            this.showSuccessMx(message).then(() => this.$router.push('/order-form')) // AI
          } else this.showFailMx(data.message) // AI
        } catch (error) {
          // AI
          this.showFailMx(error.message ?? error) // AI
        } finally {
          this.showLoading = false // AI
          this.isSubmitting = false // AI
        } // AI
      }, // AI
      cancel() {
        // AI
        this.$router.push('/order-form') // AI
      }, // AI
      showAddMaterial() {
        if (!this.dataAdd.inventoryIdExport) {
          this.showErr('Vui lòng chọn kho chuyển trước khi chọn vật tư')
          return
        }
        this.isShowAddMaterial = true
        this.fetchDevice('NORMAL')
        this.$nextTick(() => {
          this.$bvModal.show('add-material')
        })
      },
      updateStatus(data) {
        this.dataAdd.devices.push(data)
        this.$bvModal.hide('add-material')
        this.isShowAddMaterial = false
      },
      onHidden() {
        this.isShowAddMaterial = false
      },
      async fetchDevice(kind) {
        try {
          this.showLoading = true
          const params = {
            kind: kind,
            inventoryIds: [this.dataAdd.inventoryIdExport],
          }
          const response = await DeviceService.listDevice(params)
          this.dataMaterial = response.data.devices.map(item => {
            return {
              id: item.id,
              text: item.categoryName,
              serial: item.serial,
              type: item.type,
              unit: item.unit,
            }
          })
          this.dataFilter = this.dataMaterial
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
    }, // AI
  }
</script>

<style scoped>
  .form-group label {
    margin-bottom: 0.5rem;
    font-weight: 500;
  }

  .breadcrumb-area {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }

  .quantity-input {
    text-align: center;
  }

  .order-items-section {
    border: 1px solid #e0e0e0;
    border-radius: 5px;
    padding: 15px;
  }

  .item-name {
    font-weight: 500;
  }

  label {
    font-size: 14px;
  }
</style>
